import React, { useEffect, useState,useRef } from "react";
import useRequest from "@/utils/useRequest";

const UseWscCustomColumns = ({ key }) => {
    const { request } = useRequest();
    const mounted = useRef();
    const [isLoading,setLoading] = useState(true);
    const [colsettings,setColsettings] = useState([]);
    //初始化加载默认列表
    useEffect(() => {
        mounted.current = true;
        Refresh();
        return () => {
            mounted.current = false;
        }
    }, [key]);

    const GetColumnsSetting = async (key) => {
        const result = await request("/api/v2/private/columns/findone", "POST", "json", { key:key });
        return result;
    };
    
    //更新数据
    const Refresh = async () => {
        let result = await GetColumnsSetting(key);
        if (mounted.current) {
            if (result.success) {
                
                setColsettings(result.data?JSON.parse(result.data.Data):[]);
            }
            setLoading(false);
        }
    }

    return { Refresh,colsettings }
}

export default UseWscCustomColumns;